<template>
  <div class="loader-mask">
    <div class="loader">
      <img src="@/assets/loading.gif" class="width_full" alt="">
    </div>
  </div>
</template>

<style scoped>
.loader-mask {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loader {
  width: 250px;
}
</style>